<template>
  <div class="w-full py-6 box-border">
    <header class="pl-5 pr-4 border-l-4 border-solid border-theme text-medium-x text-theme-black-850 font-semibold">
      联系我们
    </header>
    <div class="mt-2 pl-6 pr-4 box-border text-medium text-theme-black-850 leading-24">
      <p>如您在使用上有任何问题或意见</p>
      <p>请微信扫码联系客服</p>
    </div>
    <img :src="`${baseUrl}img/code/Customer.Service.png`" class="mt-2 ml-6 w-w-22 h-h-22" />
  </div>
</template>

<script>
export default {
  name: 'AsideContactUs'
}
</script>